import { getCountriesForPermissions } from '../helpers';
import { AppPermissions } from '../types';
import { AppState } from './AppState';

export const preferencesSelector = (state: AppState) => state.preferences;
export const themeSelector = (state: AppState) => state.preferences.theme;
export const serviceWorkerUpdatedSelector = (state: AppState) =>
  state.preferences.serviceWorkerUpdated;
export const serviceWorkerRegistrationSelector = (state: AppState) =>
  state.preferences.serviceWorkerRegistration;

export const isAuthenticatedSelector = (state: AppState) => state.user.isAuthenticated;
export const userPermissionsSelector = (state: AppState) => state.user.permissions;
export const userPermissionsDataSelector = (state: AppState) => state.user.permissions.data;
export const userPermissionsLoadedSelector = (state: AppState) => state.user.permissions.loaded;
export const userInfoSelector = (state: AppState) => state.user.info;
export const userInfoNameSelector = (state: AppState) => state.user.info?.name;

export const isModeModalSelector = (state: AppState) => state.layout.isModeModal;
export const isSidebarOpenSelector = (state: AppState) => state.layout.isSidebarOpen;

export const masterDataSelector = (state: AppState) => state.parameters.masterData;
export const masterDataDataSelector = (state: AppState) => state.parameters.masterData.data;
export const masterDataLoadedSelector = (state: AppState) => state.parameters.masterData.loaded;
export const activeCountriesSelector = (state: AppState) => state.parameters.activeCountries;
export const activeCountriesDataSelector = (state: AppState) =>
  state.parameters.activeCountries.data;
export const activeCountriesLoadedSelector = (state: AppState) =>
  state.parameters.activeCountries.loaded;

export const filterParametersSelector = (state: AppState) => state.parameters.parameters;
export const filterParametersDataSelector = (state: AppState) => state.parameters.parameters.data;
export const filterParametersLoadedSelector = (state: AppState) =>
  state.parameters.parameters.loaded;

export const reportPosOptionsSelector = (state: AppState) => state.report.posOptions;
export const reportFilterSelector = (state: AppState) => state.report.filters;
export const reportFilterCountrySelector = (state: AppState) => state.report.filters.country;
export const reportFilterCountryCodeSelector = (state: AppState) =>
  state.report.filters.countryCode;
export const reportFilterStoresSelector = (state: AppState) => state.report.filters.stores;
export const reportConciliationDetailFilterStoresSelector = (state: AppState) =>
  state.report.filters.conciliationDetailFilters.stores;
export const reportConciliationDetailFilterStartDateSelector = (state: AppState) =>
  state.report.filters.conciliationDetailFilters.startDate;
export const reportConciliationDetailFilterEndDateSelector = (state: AppState) =>
  state.report.filters.conciliationDetailFilters.endDate;
export const reportFilterSegmentsSelector = (state: AppState) => state.report.filters.segments;
export const reportFilterPosSelector = (state: AppState) => state.report.filters.pos;
export const reportFilterDifferenceTypeSelector = (state: AppState) =>
  state.report.filters.differenceType;
export const reportFilterStartDateSelector = (state: AppState) => state.report.filters.startDate;
export const reportFilterEndDateSelector = (state: AppState) => state.report.filters.endDate;
export const reportFilterStartBusinessDateSelector = (state: AppState) =>
  state.report.filters.startBusinessDate;
export const reportFilterEndBusinessDateSelector = (state: AppState) =>
  state.report.filters.endBusinessDate;
export const reportFilterStartOperationDateSelector = (state: AppState) =>
  state.report.filters.startOperationDate;
export const reportFilterEndOperationDateSelector = (state: AppState) =>
  state.report.filters.endOperationDate;
export const reportFilterStartAccountingDateSelector = (state: AppState) =>
  state.report.filters.startAccountingDate;
export const reportFilterEndAccountingDateSelector = (state: AppState) =>
  state.report.filters.endAccountingDate;
export const reportFilterStoreMotherChildSelector = (state: AppState) => state.report.filters.pod;
export const reportFilterAppliedSelector = (state: AppState) => state.report.filterApplied;
export const reportFilterAccountingEntriesFieldsSelector = (state: AppState) =>
  state.report.filters.accountingEntriesFields;

export const reportConciliationDetailMetaSelector = (state: AppState) =>
  state.report.conciliationDetailMeta;

export const reportConciliationDetailFilterByErrorSelector = (state: AppState) =>
  state.report.conciliationDetailMeta.filterByError;

export const reportConciliationHeaderMetaSelector = (state: AppState) =>
  state.report.conciliationHeaderMeta;

export const reportConciliationHeaderFilterByStateSelector = (state: AppState) =>
  state.report.conciliationHeaderMeta.filterByState;

export const reportConciliationDetailSelector = (state: AppState) =>
  state.report.conciliationDetail;

export const reportConciliationHeaderSelector = (state: AppState) =>
  state.report.conciliationHeader;

export const reportConciliationDetailLoadingSelector = (state: AppState) =>
  state.report.conciliationDetail.loading;
export const reportConciliationHeaderLoadingSelector = (state: AppState) =>
  state.report.conciliationHeader.loading;
export const ConciliationHeaderStateSelector = (state: AppState) => state.parameters.parameters;
export const ConciliationDetailErrorsTypesSelector = (state: AppState) =>
  state.parameters.parameters;
export const reportOpStructuresFilterSelector = (state: AppState) =>
  state.report.opStructuresFilters;
export const reportOpStructuresFilterAgreementSelector = (state: AppState) =>
  state.report.opStructuresFilters.agreement;
export const reportOpStructuresFilterRegionalManagementSelector = (state: AppState) =>
  state.report.opStructuresFilters.regionalMgmt;
export const reportOpStructuresFilterRegionSelector = (state: AppState) =>
  state.report.opStructuresFilters.region;
export const reportOpStructuresFilterManagementSelector = (state: AppState) =>
  state.report.opStructuresFilters.management;
export const reportOpStructuresFilterSupervisionSelector = (state: AppState) =>
  state.report.opStructuresFilters.supervision;
export const reportOpStructuresFilterCompanySelector = (state: AppState) =>
  state.report.opStructuresFilters.company;
export const reportMastersImportFilterSelector = (state: AppState) =>
  state.report.mastersImportFilters;
export const reportMastersImportFilterCountrySelector = (state: AppState) =>
  state.report.mastersImportFilters.countries;
export const reportMastersImportFilterStartImportDateSelector = (state: AppState) =>
  state.report.mastersImportFilters.startImportDate;
export const reportMastersImportFilterEndImportDateSelector = (state: AppState) =>
  state.report.mastersImportFilters.endImportDate;
export const reportMastersImportFilterStateSelector = (state: AppState) =>
  state.report.mastersImportFilters.state;
export const reportFilterFederativeEntitySelector = (state: AppState) =>
  state.report.filters.federativeEntities;
export const reportFranchiseTypeFilterSelector = (state: AppState) =>
  state.report.filters.franchiseTypes;
export const reportFilterConciliationHeaderStateSelector = (state: AppState) =>
  state.report.filters.conciliationHeaderFilters.conciliationHeaderState;
export const reportFilterConciliationDetailErrorsSelector = (state: AppState) =>
  state.report.filters.conciliationDetailFilters.conciliationDetailErrors;
export const conciliationHeaderIdSelector = (state: AppState) =>
  state.report.filters.conciliationHeaderFilters.conciliationHeaderId;
export const reportFilterThirdPartySalesByItemsGroupBySelector = (state: AppState) =>
  state.report.filters.thirdPartySalesByItemsGroupBy;
export const reportMastersImportSelector = (state: AppState) => state.report.mastersImport;
export const reportMastersImportLoadingSelector = (state: AppState) =>
  state.report.mastersImport.loading;
export const reportMastersTypesSelector = (state: AppState) => state.report.mastersTypes;
export const reportMastersTypesLoadingSelector = (state: AppState) =>
  state.report.mastersTypes.loading;

export const reportMasterImportExecutionLoadingSelector = (state: AppState) =>
  state.report.mastersImportExecution.loading;

export const reportFiscalDetailSelector = (state: AppState) => state.report.fiscalDetail;
export const reportFiscalDetailLoadingSelector = (state: AppState) =>
  state.report.fiscalDetail.loading;

export const reportFiscalDetailFilterSelector = (state: AppState) =>
  state.report.fiscalDetailFilters;
export const reportFiscalDetailFilterCountrySelector = (state: AppState) =>
  state.report.fiscalDetailFilters.countries;
export const reportFiscalDetailFilterStartDateSelector = (state: AppState) =>
  state.report.fiscalDetailFilters.startDate;
export const reportFiscalDetailFilterEndDateSelector = (state: AppState) =>
  state.report.fiscalDetailFilters.endDate;
export const reportFiscalDetailFilterStoreSelector = (state: AppState) =>
  state.report.fiscalDetailFilters.stores;

// =============================================================================================================
// DASHBOARD CONCILIATION/CARDS
// =============================================================================================================
export const dashboardStatusYesterdaySelector = (state: AppState) =>
  state.dashboard.conciliations.statuses.yesterday;

export const dashboardStatusCurrentMonthSelector = (state: AppState) =>
  state.dashboard.conciliations.statuses.currentMonth;

export const dashboardStatusLastMonthSelector = (state: AppState) =>
  state.dashboard.conciliations.statuses.lastMonth;

export const dashboardConciliationsStateSelector = (state: AppState) =>
  state.dashboard.conciliations.statuses.multiCountry;

export const dashboardCountrySelectedSelector = (state: AppState) =>
  state.dashboard.conciliations.activeCountry;

export const singleCountryDashboardSelector = (state: AppState) =>
  state.dashboard.conciliations.singleCountry;

export const dashboardAutoUpdateTimerSelector = (state: AppState) => state.dashboard.autoUpdate;

export const dashboardMastersStatus2Selector = (state: AppState) => state.dashboard.masterStatus2;
export const dashboardSovosImportStatusesSelector = (state: AppState) =>
  state.dashboard.fiscalStatus.sovosImportStatuses;

export const erroHttpErrorSelector = (state: AppState) => state.error.httpError;
export const erroValidationErrorsSelector = (state: AppState) => state.error.validationErrors;

export const notificationsQueueSelector = (state: AppState) => state.notifications.queue;

export const exportsDownloadingSelector = (state: AppState) => state.exports.downloading;

export const reprocessParametersSelector = (state: AppState) => state.reprocess.parameters;

export const reprocessFilterSelector = (state: AppState) => state.reprocess.filters;
export const countriesRulesSelector = (state: AppState) =>
  state.parameters.parameters.data?.countriesRules;

export const activeConciliationRulesSelector = (state: AppState) => {
  const rulesData = countriesRulesSelector(state);
  const selectedCountryId = reportFilterCountryCodeSelector(state);

  if (!rulesData || !selectedCountryId) return [];

  const activeIds = rulesData.assignments[selectedCountryId];

  if (!activeIds || activeIds.length === 0) return [];

  return activeIds
    .map((id: number) => rulesData.definitions.find(def => def.id === id))
    .filter((def): def is NonNullable<typeof def> => Boolean(def));
};

// =============================================================================================================
// Report Limit Selectors
// =============================================================================================================
export const filterLimitParametersSelector = (state: AppState) => state.parameters.parameters;
export const filterLimitParametersDataSelector = (state: AppState) =>
  state.parameters.parameters.data;

export const reportLimitsSelector = (state: AppState) =>
  state.parameters.parameters.data?.reportLimits;

export const reportDetailLimitDaysSelector = (state: AppState) =>
  state.parameters.parameters.data?.reportLimits?.detailLimitDays ?? 5;

export const reportHeaderLimitDaysSelector = (state: AppState) =>
  state.parameters.parameters.data?.reportLimits?.headerLimitDays ?? 3;

export const synchroLimitDaysSelector = (state: AppState) =>
  state.parameters.parameters.data?.reportLimits?.synchroLimitDays ?? 10;

// =============================================================================================================
// DASHBOARD TOTALS/CARDS (FLEX vs SOVOS)
// =============================================================================================================
export const dashboardTotalsYesterdaySelector = (state: AppState) =>
  state.dashboard.conciliations.totals.yesterday;

export const dashboardTotalsCurrentMonthSelector = (state: AppState) =>
  state.dashboard.conciliations.totals.currentMonth;

export const dashboardTotalsLastMonthSelector = (state: AppState) =>
  state.dashboard.conciliations.totals.lastMonth;

export const dashboardClosureEvolutionSelector = (state: AppState) =>
  state.dashboard.closureEvolution;

export const dashboardClosureEvolutionFilterStartDateSelector = (state: AppState) =>
  state.dashboard.closureEvolutionFilters.startDate;

export const dashboardClosureEvolutionFilterEndDateSelector = (state: AppState) =>
  state.dashboard.closureEvolutionFilters.endDate;

export const reprocessMaxDateRangeSelector = (state: AppState) =>
  state.reprocess.parameters.data?.configuration?.max_date_range ?? 5;

const synchroStateSelector = (state: AppState) => state.synchro;

export const synchroDataSelector = (state: AppState) => synchroStateSelector(state).data;

export const synchroLoadingSelector = (state: AppState) => synchroStateSelector(state).loading;

export const synchroExecutionLoadingSelector = (state: AppState) =>
  synchroStateSelector(state).executionLoading;

export const synchroErrorSelector = (state: AppState) => synchroStateSelector(state).error;

export const synchroEnabledCountriesSelector = (state: AppState): string[] => {
  const {
    parameters: { data },
  } = state.parameters;
  return data?.synchro?.enabledCountries?.value || [];
};

export const isSynchroEnabledForCountrySelector = (
  state: AppState,
  countryCode: string
): boolean => {
  const enabledCountries = synchroEnabledCountriesSelector(state);
  return enabledCountries.includes(countryCode);
};

export const synchroAuthorizedCountriesSelector = (state: AppState) => {
  const permissionsData = userPermissionsDataSelector(state);
  const activeCountries = activeCountriesDataSelector(state);
  const enabledCountries = synchroEnabledCountriesSelector(state);

  return getCountriesForPermissions(
    [AppPermissions.SYNCHRO_4_ME],
    permissionsData,
    activeCountries
  ).filter(c => enabledCountries.includes(c.countryCode));
};

export const canUserSeeSynchroSelector = (state: AppState): boolean => {
  if (!filterParametersLoadedSelector(state)) return true;

  return synchroAuthorizedCountriesSelector(state).length > 0;
};

export const managementReportMaxDateRangeSelector = (state: AppState): number => {
  const { data } = state.parameters.parameters;

  const limitValue = data?.managementReportFilterLimit?.value;

  return limitValue ? parseInt(limitValue, 10) : 31;
};

export const parametricStoresListSelector = (state: AppState) => state.parametricStores.list;
export const parametricStoresSaveSelector = (state: AppState) => state.parametricStores.save;
export const parametricStoresRemoveSelector = (state: AppState) => state.parametricStores.remove;

export const parametricStoresEnabledCountriesSelector = (state: AppState): string[] => {
  const {
    parameters: { data },
  } = state.parameters;
  return data?.parametricStores?.enabledCountries?.value || [];
};

// Los paises que el usuario puede ver: los que le dan sus permisos, cruzados con los que estan
// habilitados en el parametro. El cruce contra los permisos lo hace el mismo helper que usan las
// demas pantallas.
export const parametricStoresAuthorizedCountriesSelector = (state: AppState) => {
  const habilitados = parametricStoresEnabledCountriesSelector(state);
  const autorizados = getCountriesForPermissions(
    [AppPermissions.PARAMETRIC_STORES],
    userPermissionsDataSelector(state),
    activeCountriesDataSelector(state)
  );
  return autorizados.filter(c => c && habilitados.includes(c.countryCode));
};

export const canUserSeeParametricStoresSelector = (state: AppState): boolean => {
  if (!filterParametersLoadedSelector(state)) return true;

  // Tener permiso no alcanza: el pais tiene que estar habilitado en el parametro.
  return parametricStoresAuthorizedCountriesSelector(state).length > 0;
};

// El pais con el que abre la pantalla: el primero del parametro que el usuario tenga disponible,
// para que el orden lo decida el parametro y no el orden de los permisos, que cambia por usuario.
export const parametricStoresDefaultCountrySelector = (state: AppState): string => {
  const disponibles = parametricStoresAuthorizedCountriesSelector(state);
  if (disponibles.length === 0) return '';

  const habilitados = parametricStoresEnabledCountriesSelector(state);
  const primero = habilitados.find(c => disponibles.some(d => d.countryCode === c));
  return primero || disponibles[0].countryCode;
};

export const conciliationMethodSelector = (state: AppState) => {
  const rulesData = countriesRulesSelector(state);
  const selectedCountryId = reportFilterCountryCodeSelector(state);

  if (!rulesData || !selectedCountryId) return undefined;

  return rulesData.conciliationMethods[selectedCountryId];
};
